import { createAsyncThunk } from "@reduxjs/toolkit";
import { EyengageActions } from "./EyengageSlice";
import { ChildrenStoreData, EyengageFilterCategory, EyengagePostListResponse } from "src/shared/types/src";
import { fetchEyengagePostsApi, fetchEymanageSettings } from "src/shared/services/src";
import { updateEyengageLastUpdateTime } from "../appTimers/AppTimerHandler";
import { GlobalErrorActions } from "../globalError/GlobalErrorSlice";

export const updateEyengagePostsLoader = createAsyncThunk(
    "updateEyengagePostsLoader", async (payload: { postsLoading: boolean }, { dispatch }) => {
        dispatch(EyengageActions.setPostsLoader({ isLoading: payload.postsLoading }));
    }
);

export const updateEyengagePostsPaginatedLoader = createAsyncThunk(
    "updateEyengagePostsPaginatedLoader", async (payload: { paginatedLoading: boolean }, { dispatch }) => {
        dispatch(EyengageActions.setPostsPaginatedLoader({ paginatedLoading: payload.paginatedLoading }));
    }
);

export const updateEyengageFilterApplied = createAsyncThunk(
    "updateEyengageFilterApplied", async (payload: { filterApplied: boolean }, { dispatch }) => {
        dispatch(EyengageActions.setIsEyengageFilterApplied(payload.filterApplied));
    }
);

export const fetchEyengagePosts = createAsyncThunk(
    'fetchEyengagePosts',
    async ({ child, page, categories, type }: { child: ChildrenStoreData, page: number, categories?: string, type?: string }, { dispatch }) => {
        try {
            if (page === 1) {
                await dispatch(EyengageActions.resetEyengagePostsState());
                dispatch(updateEyengagePostsLoader({ postsLoading: true }));
            }
            else dispatch(updateEyengagePostsPaginatedLoader({ paginatedLoading: true }));
            const queryObj = { page, categories, type };
            if (!categories) delete queryObj['categories'];
            if (!type) delete queryObj['type'];
            const response: EyengagePostListResponse = await fetchEyengagePostsApi({ child, ...queryObj });
            // const response = {} as any;
            if (response && Object.keys(response).length) {
                if (page === 1) {
                    // save the current time to async store
                    dispatch(updateEyengageLastUpdateTime({ eyengageLastUpdateTime: new Date().getTime() }));
                }
                dispatch(EyengageActions.appendEyengagePosts({ posts: response.posts, pagination: response.pagination, settings: response.settings }));
            }
        } catch (error) {
            console.log("Error fetching posts", error);
            dispatch(GlobalErrorActions.setError({ isError: true, message: 'Could not fetch the posts. Try again!' }));
        } finally {
            dispatch(updateEyengagePostsLoader({ postsLoading: false }));
            dispatch(updateEyengagePostsPaginatedLoader({ paginatedLoading: false }));
        }
    }
);

export const fetchEymanSettings = createAsyncThunk(
    'fetchEymanSettings',
    async ({ child }: { child: ChildrenStoreData, }, { dispatch }) => {
        try {
            await dispatch(EyengageActions.setEymanSettingsLoader({ settingsLoading: true }));
            const response = await fetchEymanageSettings({ child });
            if (response && Object.keys(response).length) {
                dispatch(EyengageActions.setFilterCategories(response?.settings?.eyengage?.categories || []));
            }
        } catch (error) {
            console.log("error in fetch eyman settings handler : ", error);
        } finally {
            //  dispatch(updateSettingsLoader({ settingsLoading: false }));
            await dispatch(EyengageActions.setEymanSettingsLoader({ settingsLoading: false }));
        }
    }
);

export const updateSelectedPostTypeFilter = createAsyncThunk(
    "updateSelectedPostTypeFilter", async (payload: { postFilter: string[] }, { dispatch }) => {
        dispatch(EyengageActions.setPostTypeFilter(payload.postFilter));
    }
);

export const updateSelectedPostCategoryFilter = createAsyncThunk(
    "updateSelectedPostCategoryFilter", async (payload: { categoryFilter: EyengageFilterCategory[] }, { dispatch }) => {
        dispatch(EyengageActions.setPostCategoriesFilter(payload.categoryFilter));
    }
);